import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { LogOut, Building2, FolderOpen, FileText, DollarSign, MessageSquare, ImageIcon } from "lucide-react";
import portalApi from "@/lib/portalApi";

export default function PortalLayout() {
    const nav = useNavigate();
    const [me, setMe] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const t = localStorage.getItem("forge_portal_token");
        if (!t) {
            nav("/portal/login", { replace: true });
            return;
        }
        portalApi.get("/portal/me").then(({ data }) => {
            setMe(data.portal_user);
            setLoading(false);
        }).catch(() => nav("/portal/login", { replace: true }));
    }, [nav]);

    const logout = () => {
        localStorage.removeItem("forge_portal_token");
        localStorage.removeItem("forge_portal_user");
        nav("/portal/login", { replace: true });
    };

    if (loading) {
        return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Loading portal…</div>;
    }
    if (!me) return null;

    const typeBadge = {
        client: "Client Portal",
        investor: "Investor Portal",
        lender: "Lender Portal",
        subcontractor: "Subcontractor Portal",
    }[me.portal_type] || "Portal";

    return (
        <div className="min-h-screen bg-background text-foreground" data-testid="portal-layout">
            <header className="h-14 border-b border-border flex items-center justify-between px-4 md:px-6 sticky top-0 bg-background/95 backdrop-blur z-40">
                <div className="flex items-center gap-3">
                    <Building2 size={18} />
                    <div className="text-sm">
                        <div className="font-medium tracking-tight" data-testid="portal-org-name">{me.organization_name || "ForgeOS"}</div>
                        <div className="text-[10px] uppercase tracking-widest text-muted-foreground" data-testid="portal-type-badge">{typeBadge}</div>
                    </div>
                </div>
                <div className="flex items-center gap-3 text-sm">
                    <span className="hidden md:inline text-muted-foreground" data-testid="portal-user-email">{me.email}</span>
                    <button onClick={logout} className="flex items-center gap-1.5 border border-border px-2.5 py-1.5 text-xs hover:bg-secondary" data-testid="portal-logout">
                        <LogOut size={12} /> Sign out
                    </button>
                </div>
            </header>

            <div className="max-w-6xl mx-auto p-4 md:p-6" data-testid="portal-content">
                <Outlet context={{ me }} />
            </div>
        </div>
    );
}
